import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Sidebar';
import HeaderGlobal from '../../components/HeaderGlobal';
import RolesList from './RolesList';
import RoleForm from './RoleForm';
import PermissionsTable from './PermissionsTable';
import NewRoleModal from './NewRoleModal';
import ModalLux from '../../components/ModalLux';
import styles from '../../styles/RolesPermissionsStyles/RolesPermissions.module.css';
import { getRoles, createRol, updateRol } from '../../api/roles';

function RolesPermissionsScreen() {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPreview, setShowPreview] = useState(false);
  const [showNewRoleModal, setShowNewRoleModal] = useState(false);
  const [showRoleModal, setShowRoleModal] = useState(false);

  // Cargar roles al montar el componente
  useEffect(() => {
    loadRoles();
  }, []);

  const loadRoles = async () => {
    try {
      setLoading(true);
      const data = await getRoles();
      setRoles(data);
      if (data.length > 0 && !selectedRole) {
        setSelectedRole(data[0]);
      }
    } catch (error) {
      console.error('Error al cargar roles:', error);
      alert('Error al cargar roles');
    } finally {
      setLoading(false);
    }
  };

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
    setShowRoleModal(true);
  };

  const handleSaveRole = async (roleData) => {
    try {
      if (selectedRole && selectedRole.id_rol) {
        const updated = await updateRol(selectedRole.id_rol, roleData);
        setRoles(roles.map(r => r.id_rol === updated.id_rol ? updated : r));
        setSelectedRole(updated);
        alert('Rol actualizado exitosamente');
        setShowRoleModal(false);
      }
    } catch (error) {
      console.error('Error al guardar rol:', error);
      alert('Error al guardar rol');
    }
  };

  const handlePreview = () => {
    setShowPreview(!showPreview);
  };

  const handleCopyPermissions = () => {
    console.log('Copiando permisos de otro rol');
  };

  const handleNewRole = () => {
    setShowNewRoleModal(true);
  };

  const handleCloseNewRoleModal = () => {
    setShowNewRoleModal(false);
  };

  const handleCreateNewRole = async (newRoleData) => {
    try {
      const created = await createRol(newRoleData);
      setRoles([created, ...roles]);
      setSelectedRole(created);
      setShowNewRoleModal(false);
      alert('Rol creado exitosamente');
    } catch (error) {
      console.error('Error al crear rol:', error);
      alert('Error al crear rol');
    }
  };

  if (loading) {
    return (
      <div className={styles.layout}>
        <div className={styles.sidebarColumn}>
          <Sidebar />
        </div>
        <div className={styles.contentColumn}>
          <div className={styles.contentArea}>
            <p style={{ textAlign: 'center', padding: '20px' }}>Cargando roles...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.layout}>
      <div className={styles.sidebarColumn}>
        <Sidebar />
      </div>
      <div className={styles.contentColumn}>
        <HeaderGlobal title="Roles y Permisos" />
        <div className={styles.contentArea}>
          <div className={styles.contentWrapper}>
            <div className={styles.mainContent}>
              {/* Left Panel - Roles List */}
              <div className={styles.leftPanel}>
                <RolesList 
                  roles={roles}
                  selectedRole={selectedRole}
                  onRoleSelect={handleRoleSelect}
                  onNewRole={handleNewRole}
                />
              </div>
              {/* Right Panel vacío para centrar la experiencia en el modal */}
              <div className={styles.rightPanel}></div>
            </div>
          </div>
        </div>
        {/* Modal flotante para editar/ver rol */}
        <ModalLux open={showRoleModal} onClose={() => setShowRoleModal(false)} title={selectedRole ? `Nombre del rol: ${selectedRole.nombre_rol}` : ''}>
          {selectedRole && (
            <>
              <RoleForm role={selectedRole} onSave={handleSaveRole} />
              <PermissionsTable roleId={selectedRole.id_rol} onPermissionsSaved={() => { loadRoles(); setShowRoleModal(false); }} />
            </>
          )}
        </ModalLux>
        {/* New Role Modal */}
        <NewRoleModal
          isOpen={showNewRoleModal}
          onClose={handleCloseNewRoleModal}
          onSave={handleCreateNewRole}
        />
      </div>
    </div>
  );
}

export default RolesPermissionsScreen;
